import { isNil } from "lodash";

import {
  FREE_CARRIER_SUBSCRIPTION_PLANS,
  LIMITED_BOOKING_CARRIERS_SUBSCRIPTION_PLANS,
  PLANS_WITHOUT_STRIPE_CUSTOMER,
} from "../constants";

export function hasPaidCarrierSubscription(
  subscription: CondensedSubscription | null,
) {
  return (
    !isNil(subscription) &&
    (subscription?.subscription_plan === "CARRIER_OWNER_OPERATOR" ||
      subscription?.subscription_plan === "CARRIER_SMALL_BUSINESS" ||
      subscription?.subscription_plan === "CARRIER_ENTERPRISE" ||
      subscription?.subscription_plan === "CARRIER_BRONZE" ||
      subscription?.subscription_plan === "CARRIER_SILVER" ||
      subscription?.subscription_plan === "CARRIER_GOLD" ||
      subscription?.subscription_plan === "CARRIER_PLATINUM" ||
      subscription?.subscription_plan === "CARRIER_ENTERPRISE_2")
  );
}

export function carrierSubHasLimitedBookings(subscription: SubscriptionPlan) {
  return LIMITED_BOOKING_CARRIERS_SUBSCRIPTION_PLANS.has(subscription);
}

export function isEssentialsV2Carrier(
  subscription: CondensedSubscription | null,
) {
  return subscription?.subscription_plan === "CARRIER_ESSENTIALS_V2";
}

export function isEssentialsCarrier(
  subscription: CondensedSubscription | null,
): boolean {
  return (
    subscription?.subscription_plan === "CARRIER_ESSENTIALS" ||
    subscription?.subscription_plan === "CARRIER_ESSENTIALS_V2"
  );
}

// A billing portal session is created against a StripeCustomer, so plans billed
// outside Stripe cannot open one and must be offered a different recovery path.
export function canOpenStripeBillingPortal(
  subscription: CondensedSubscription | null,
): boolean {
  return (
    subscription !== null &&
    !PLANS_WITHOUT_STRIPE_CUSTOMER.has(subscription.subscription_plan)
  );
}

export function isFreeCarrierSubscription(
  subscription: CondensedSubscription | null,
): boolean {
  return (
    subscription !== null &&
    FREE_CARRIER_SUBSCRIPTION_PLANS.has(subscription.subscription_plan)
  );
}

export function isFreeTierShipperSubscription(
  subscription: CondensedSubscription | null,
): boolean {
  return subscription?.subscription_plan === "SHIPPER_FREE_TIER";
}

export function getSubscriptionPlanLabel(plan: SubscriptionPlan): string {
  if (plan === "CARRIER_ESSENTIALS" || plan === "CARRIER_ESSENTIALS_V2") {
    return "Carrier Essentials";
  }
  return plan
    .toLowerCase()
    .split("_")
    .map((word) => (word[0] ?? "").toUpperCase() + word.substring(1))
    .join(" ");
}
